export default class AppFunctions {
  // 修改：直接操作传入的DOM元素，而不是通过选择器查找
  static addClass(element, className) {
    if (element && element.classList) {
      element.classList.add(className);
    }
  }

  static removeClass(element, className) {
    if (element && element.classList) {
      element.classList.remove(className);
    }
  }

  static toggleClass(element, className) {
    if (element && element.classList) {
      element.classList.toggle(className);
    }
  }

  // 其他方法保持不变...
  
  static flatDeep(arr, d = 1) {
    return d > 0
      ? arr.reduce(
        (acc, val) =>
          acc.concat(Array.isArray(val) ? this.flatDeep(val, d - 1) : val),
        []
      )
      : arr.slice();
  }

  static slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w-]+/g, "") // Remove all non-word chars
      .replace(/--+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  }

  static containsObject(obj, list) {
    let i;
    for (i = 0; i < list.length; i++) {
      if (list[i].slug === obj.slug) {
        return i;
      }
    }

    return -1;
  }
}